import{gql as e}from"@apollo/client";const o=e`
  query getCustomFields(
    $projectId: String!,
    $scope: ECustomFieldScope!,
    $userId: Int,
    $userTypeId: Int,
    $shouldIncludeNonLinked: Boolean
  ) {
    customField {
      getCustomFields(
        projectId: $projectId,
        scope: $scope,
        userTypeId: $userTypeId,
        shouldIncludeNonLinked: $shouldIncludeNonLinked
      ) {
        id
        name
        ... on CustomFieldMultiResponseGraphType {
          isPubliclyAvailable
          allowMultipleResponse
          type
          availableOptions {
            id
            isDefault
            value
            customFieldMultiResponseId
          }
        }
        responses(userId: $userId) {
          id
          ... on CustomFieldResponseDateGraphType {
            dateTime
          }
          ... on CustomFieldResponseMultiResponseGraphType {
            optionId
          }
          ... on CustomFieldResponseNumberGraphType {
            number
          }
          ... on CustomFieldResponseTextGraphType {
            text
          }
          ... on CustomFieldResponseBooleanGraphType {
            value
          }
        }
      }
    }
  }
`;export{o as GET_CUSTOM_FIELDS_QUERY};
//# sourceMappingURL=useGetCustomFields.graphql.js.map
